import { formatRegistration } from "@autopic/shared";
import styles from "./Plate.module.css";

interface PlateProps {
  registration: string;
  /** Country tab on the blue band. */
  country?: "UK" | "GB";
  size?: "sm" | "md" | "lg";
  className?: string;
}

/**
 * UK number-plate motif: blue country band + yellow body with uppercase,
 * letter-spaced registration. Reused across the flow as the vehicle identity.
 */
export function Plate({ registration, country = "UK", size = "md", className }: PlateProps) {
  return (
    <span
      className={[styles.plate, styles[size], className].filter(Boolean).join(" ")}
      aria-label={`Registration ${formatRegistration(registration)}`}
    >
      <span className={styles.band} aria-hidden="true">
        {country}
      </span>
      <span className={styles.reg}>{formatRegistration(registration)}</span>
    </span>
  );
}
